// extracted by mini-css-extract-plugin
export var container = "_80-0";
export var containerTopRight = "_80-1";